function f(u, r) {
  return Array.isArray(r) ? r[u] ? r[u] : r[0] ? r[0] : "" : r || "";
}
export {
  f as getItemTextAlignment
};
